const TrophyOutlineIcon = ({ color = '#848484' }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 3h8v3.5a4 4 0 0 1-8 0V3Z" stroke={color} strokeWidth="1.4" strokeLinejoin="round" />
    <path d="M6 4H3.5v2A2.5 2.5 0 0 0 6 8.5M14 4h2.5v2A2.5 2.5 0 0 1 14 8.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    <path d="M10 10.5v3M7 17h6M8.5 17l.5-3.5h2l.5 3.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default TrophyOutlineIcon
